

export const CREATE_REPORT_REQUEST = 'reports/CREATE_REPORT_REQUEST';
export const CREATE_REPORT_SUCCESS = 'reports/CREATE_REPORT_SUCCESS';
export const CREATE_REPORT_FAILURE = 'reports/CREATE_REPORT_FAILURE';



export const UPDATE_FIELD = 'reports/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'reports/SET_DEFAULT_DATA';
